export default {
    url: 'https://sso.adventa.solutions/auth/', 
    realm: 'Adventa', 
    clientId: 'admin-catalogos-joy', 
    onLoad:'check-sso',
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
}